import React, { useContext } from 'react';
import Context from "../context/context";

function TotalResultsBottom(){

    const {filteredItems, currentPage} = useContext(Context);


    let total_items = filteredItems.length;
    let total_viewed = currentPage * 12;
    if (total_viewed > filteredItems.length){
      total_viewed = filteredItems.length;
    }

    let total_text = "You have viewed " + total_viewed + " of " + total_items + ".";

    if (total_items === 1){
      total_text = "You have " + total_items + " result to view.";
    }

    if (total_items === 0){
      return false;
    } else {
      return (
          <div className="total-results">
            {total_text}
          </div>
      )
    }

}

export default TotalResultsBottom;
